export const connectionCreated = (subpatch, {sourceNode, destNode, sourceType, destType}) => {

    subpatch.instances.forEach(
        instance => {
            let _sourceNode = instance.lookupObject(sourceNode);
            let _destNode = instance.lookupObject(destNode);
            _destNode.connectInlet(destType, _sourceNode, sourceType);
        });
};

export const connectionDeleted = (subpatch, {sourceNode, destNode, sourceType, destType}) => {

    subpatch.instances.forEach(
        instance => {
            let _sourceNode = instance.lookupObject(sourceNode);
            let _destNode = instance.lookupObject(destNode);

            _destNode.disconnectInlet(destType, _sourceNode, sourceType);
        });
};

